<template>
    <div class="entities-list">
        <div class="entities-list__header">
            <h1 class="entities-list__title">Кампании</h1>
        </div>

        <div class="table-container">
            <table class="entities-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Название</th>
                        <th>Рекламодатель</th>
                        <th>Бренд</th>
                        <th>Статус</th>
                        <th>Создатель</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="campaign in campaigns" :key="campaign.id">
                        <td>{{ campaign.id }}</td>
                        <td>
                            <a :href="`/guaranteed/campaigns/${campaign.id}`" class="entities-table__link">
                                {{ campaign.name }}
                            </a>
                        </td>
                        <td>{{ campaign.advertiser?.name || '—' }}</td>
                        <td>{{ campaign.brand?.name || '—' }}</td>
                        <td>
                            <span class="entities-table__badge"
                                :class="`entities-table__badge--${getDisplayStatus(campaign.status)}`">
                                {{ getDisplayStatusLabel(campaign.status) }}
                            </span>
                        </td>
                        <td>{{ campaign.created_by?.email || '—' }}</td>
                    </tr>
                    <tr v-if="campaigns.length === 0">
                        <td colspan="6" class="text-center text-muted">Нет кампаний</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapCampaignStatus, getCampaignStatusLabel } from '../../utils/campaignStatus.js';

export default {
    name: 'CampaignsListPage',
    props: {
        campaigns: {
            type: Array,
            default: () => []
        },
        userData: {
            type: Object,
            required: true
        }
    },
    methods: {
        getDisplayStatus(status) {
            return mapCampaignStatus(status);
        },
        getDisplayStatusLabel(status) {
            const displayStatus = mapCampaignStatus(status);
            return getCampaignStatusLabel(displayStatus);
        },
    }
};
</script>

<style lang="scss" scoped>
.entities-list {
    padding: 2rem;
    max-width: 1400px;
    margin: 0 auto;

    &__header {
        margin-bottom: 2rem;
    }

    &__title {
        font-size: 2rem;
        font-weight: 600;
        color: #0f172a;
        margin: 0;
    }
}

.table-container {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.entities-table {
    width: 100%;
    border-collapse: collapse;

    thead {
        background: #f8fafc;
    }

    th {
        padding: 1rem;
        text-align: left;
        font-weight: 600;
        color: #374151;
        border-bottom: 2px solid #e5e7eb;
    }

    td {
        padding: 1rem;
        border-bottom: 1px solid #e5e7eb;
        color: #1f2937;
    }

    tbody tr:hover {
        background: #f9fafb;
    }

    &__link {
        color: #007bff;
        text-decoration: none;
        font-weight: 500;

        &:hover {
            text-decoration: underline;
        }
    }

    &__badge {
        display: inline-block;
        padding: 0.25rem 0.75rem;
        border-radius: 12px;
        font-size: 0.75rem;
        font-weight: 500;
        text-transform: capitalize;

        // Упрощенные статусы
        &--active {
            background: #d4edda;
            color: #155724;
        }

        &--paused {
            background: #fff3cd;
            color: #856404;
        }

        &--finished {
            background: #f8d7da;
            color: #721c24;
        }

        &--moderation {
            background: #fff3cd;
            color: #856404;
        }

        // Старые статусы для обратной совместимости
        &--activated,
        &--booked,
        &--approve {
            background: #d4edda;
            color: #155724;
        }

        &--review,
        &--pending_approval {
            background: #fff3cd;
            color: #856404;
        }

        &--rejected,
        &--cancelled {
            background: #f8d7da;
            color: #721c24;
        }
    }

    .text-center {
        text-align: center;
    }

    .text-muted {
        color: #9ca3af;
    }
}
</style>
